<template>
    <MainContent :title="$t('parcelas.venta_parcelas', { parcela: palabra })">
        <template v-slot:header>
            <h3 class="card-title pb-3">{{ $t('parcelas.venta_parcelas', { parcela: palabra }) }}</h3>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <b-container>
                    <ContentOrLoading>
                        <Stepper
                            v-if="!loading"
                            ref="stepper"
                            :steps="steps" 
                        >
                            <template #pasoZona="{ changeStep }">
                                <VentaPasoUno @terminado="zona => { finalizarPasoUno(zona); changeStep(); }" />  
                            </template>
                            <template #pasoParcelas="{ changeStep }">
                                <VentaPasoDos ref="VentaPasoDos" :zona="zona" @terminado="(datos, cart_id) => { rellenarDatosParcelas(datos, cart_id); changeStep(); }" @cambiarZona="() => { cambiarZona(); changeStep(true); }" />
                            </template>
                            <template #pasoRellenarDatos="{ changeStep }">
                                <VentaPasoTres :datosParcelas="datosParcelas" :cart_id="cart_id" @terminado="(datos) => { rellenarDatosCompra(datos); changeStep(); }" @metodo-pago="(pago) => { setMetodoPago(pago); }" @cambiarParcelas="() => { borrarSesion(); changeStep(true); }" />
                            </template>
                            <template #pasoResumenDatos="{ changeStep }">
                                <VentaPasoCuatro :datosParcelas="datosParcelas" :cart_id="cart_id" :metodoPago="metodoPago" @terminado="() => { changeStep(); }" @cambiarDatos="() => { changeStep(true); }"  @comenzarDeNuevo="() => { borrarSesion(); cambiarZona(); $refs.stepper.currentStep -= 3; }" @nuevaCompra="() => { $refs.stepper.currentStep -= 3; }"/>
                            </template>
                        </Stepper>
                    </ContentOrLoading>
                </b-container>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent.vue";
    import VentaPasoUno from '@/components/backend/parcelas/VentaPasoUno';
    import VentaPasoDos from '@/components/backend/parcelas/VentaPasoDos';
    import VentaPasoTres from '@/components/backend/parcelas/VentaPasoTres';
    import VentaPasoCuatro from '@/components/backend/parcelas/VentaPasoCuatro';
    import Stepper from '@/components/frontend/events/compra/components/Stepper';
    import { useParcelaWord } from '@/composables/admin/parcelas/useParcelaWord';

    export default {
        setup() {
            // Snapshot el valor string del composable en `setup()` para poder
            // usarlo dentro de `data()` (los refs NO se auto-desenvuelven en script,
            // solo en template). El composable sigue disponible via `this.palabra`
            // y `this.esTerreno` para template/computed reactivos.
            const { palabra, esTerreno } = useParcelaWord();
            return {
                palabra,
                esTerreno,
                palabraWord: palabra.value,
            };
        },
        data() {
            return {
                zona: null,
                loading: false,
                datosParcelas: null,
                cart_id: null,
                reloadComponents: 0,
                metodoPago: null,
                steps: [
                    { label: "Seleccione la zona", slot: "pasoZona" },
                    { label: `Seleccione sus ${this.palabraWord}`, slot: "pasoParcelas" },
                    { label: "Rellena los datos", slot: "pasoRellenarDatos" },
                    { label: "Resumen de datos", slot: "pasoResumenDatos" }
                ]
            }
        },
        methods: {
            finalizarPasoUno(zona) {
                this.zona = zona;
            },
            cambiarZona() {
                this.zona = null;
            },
            rellenarDatosParcelas(datos, cart_id) {
                this.datosParcelas = datos;
                this.cart_id = cart_id;
            },           
            rellenarDatosCompra(datos) {
                this.datosParcelas = datos;
            },
            setMetodoPago(pago) {
                this.metodoPago = pago;
            },
            borrarSesion() {
                const params = {
                    cart_id: this.cart_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.borrar'), params).then(res => {
                    this.cart_id = null;
                    this.datosParcelas = null;
                    this.reloadComponents++;
                }).finally(() => {
                    this.loading = false;
                });
            },

        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContent,VentaPasoUno, VentaPasoDos, VentaPasoTres, VentaPasoCuatro, Stepper
        },
    }
</script>
